import React from 'react';
import './GovernanceHeader.css';

interface GovernanceHeaderProps {
  stats: {
    totalProposals: number;
    activeProposals: number;
    totalVotes: number;
    quorum: number;
  };
  onCreateProposal: () => void;
  onRefresh: () => void;
  onForceRefresh: () => void;
  loading: boolean;
}

const GovernanceHeader: React.FC<GovernanceHeaderProps> = ({ 
  stats, 
  onCreateProposal, 
  onRefresh, 
  onForceRefresh,
  loading 
}) => {
  return (
    <div className="governance-header">
      <div className="header-stats">
        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-value">{stats.totalProposals}</div>
            <div className="stat-label">Total Proposals</div>
          </div>
          <div className="stat-card">
            <div className="stat-value">{stats.activeProposals}</div>
            <div className="stat-label">Active Proposals</div>
          </div>
          <div className="stat-card">
            <div className="stat-value">{stats.totalVotes.toLocaleString()}</div>
            <div className="stat-label">Total Votes</div>
          </div>
          <div className="stat-card">
            <div className="stat-value">{stats.quorum.toFixed(1)}%</div>
            <div className="stat-label">Quorum Required</div>
          </div>
        </div>
      </div>
      
      <div className="header-controls">
        <div className="control-buttons">
          <button 
            className="btn btn-primary"
            onClick={onCreateProposal}
            disabled={loading}
          >
            Create Proposal
          </button>
          <button 
            className="btn btn-secondary"
            onClick={onRefresh}
            disabled={loading}
          >
            Refresh
          </button>
        </div>
      </div>
    </div>
  );
};

export default GovernanceHeader;
